import React, { useState, useEffect } from 'react';
import "./ChooseSongBody.css";

import { useStateValue } from "../StateProvider";
import { spotifyRateLimiter } from "../utils/SpotifyRateLimiter";
import  SearchFormNew from "./SearchBar/SearchFormNew";
import TrackListResult from "./TrackListResults";
import MeldungSongGeadded from './MeldungSongGeAdded';
import SongConfirmation from './SongConfirmation';

function ChooseSongBody() {
  const [{ suchbegriff, searchResults, user, songToAddChosen, songConfirmationNeeded, token, countUserRatings}, dispatch] = useStateValue();



  const [showSearch, setShowSearch] = useState(
    //inital value
   false

  ); //hook example

  const [showSuccessMsg, setShowSuccessMsg] = useState(
    //inital value
   0

  ); //hook example

  // Effect to pause music and hide Spotify Player UI when ChooseSong screen appears
  useEffect(() => {
    // Hide Spotify Player UI (but keep component mounted to preserve state)
    dispatch({
      type: "SET_HIDESPOTIFYPLAYERUI",
      hideSpotifyPlayerUI: true,
    });

    // Pause any currently playing music
    if (token) {
      spotifyRateLimiter.makeRequest("https://api.spotify.com/v1/me/player/pause", {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
      }).catch(() => {
        // Ignore errors if no active player or already paused
        console.log("No active player to pause or already paused");
      });
    }

    // Cleanup function to show player UI again when leaving this screen
    return () => {
      dispatch({
        type: "SET_HIDESPOTIFYPLAYERUI",
        hideSpotifyPlayerUI: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array means this runs once on mount

  // Check if user is loaded and show search form
  useEffect(() => {
    if (user !== null) {
      setShowSearch(true);
    }
  }, [user]);

  // Check if song was chosen and show success message
  useEffect(() => {
    if (songToAddChosen === 1) {
      setShowSuccessMsg(1);
    }
  }, [songToAddChosen]);



  return (


    <div className="chooseSongBody">

      {/* Show confirmation screen when song is chosen */}
      {songConfirmationNeeded && <SongConfirmation />}

      {/* Show success message after confirmation */}
      {!songConfirmationNeeded && showSuccessMsg===1 && <MeldungSongGeadded />}

      {/* Show search form when no confirmation needed and no success message */}
      {!songConfirmationNeeded && showSuccessMsg===0 && (
        <>
          <div className="introText">
            <h2>
              {countUserRatings === 0 ? (
                <>No songs were available to rate <span role="img" aria-label="info">ℹ️</span></>
              ) : (
                <>Great job! You've rated {countUserRatings} song{countUserRatings === 1 ? '' : 's'} <span role="img" aria-label="checkmark">✅</span></>
              )}
            </h2>
            <h1>Now choose the Song you want to submit:</h1>
          </div>
          {(showSearch===true) ?
            (<div>
              <SearchFormNew suchbegriff={suchbegriff} searchResults={searchResults}/>
              <TrackListResult tracks={searchResults} />
            </div>) : (<div><p>Waiting for Spotify Information.</p></div>)
          }
        </>
      )}


    </div>
  );
}

export default ChooseSongBody;
